import { Component, Input, Output, EventEmitter } from '@angular/core';

export interface TangramPreviewItem {
  platform: string;
  title: string;
  url: string;
}

@Component({
  selector: 'tangram-preview-panel',
  templateUrl: './tangram-preview-panel.component.html',
  styleUrls: ['./tangram-preview-panel.component.scss']
})
export class TangramPreviewPanelComponent {
  @Input() previewItems: TangramPreviewItem[] = [];
  @Input() hasContent: boolean = false;

  @Output() openPreview = new EventEmitter<void>();
  @Output() clearPreview = new EventEmitter<void>();

  onOpenPreview(event: Event) {
    event.preventDefault();
    if (this.hasContent) {
      this.openPreview.emit();
    }
  }

  onClearPreview() {
    this.clearPreview.emit();
  }
}
